'use client';
import React, { HTMLAttributes } from 'react';

import Image from 'next/image';
import PugliaFullMap from '@/assets/images/maps/puglia-full.png';
interface ISicilyMapZoneProps extends HTMLAttributes<HTMLDivElement> {
  region: number;
  alt?: string;
}

const zoneImageUrl: Record<number, string> = {
  1: 'https://villatravellers-prod.s3.eu-west-2.amazonaws.com/assets/images/maps/guides/sicily-west@2x.png',
  2: 'https://villatravellers-prod.s3.eu-west-2.amazonaws.com/assets/images/maps/guides/sicily-north@2x.png',
  3: 'https://villatravellers-prod.s3.eu-west-2.amazonaws.com/assets/images/maps/guides/sicily-east@2x.png',
  4: 'https://villatravellers-prod.s3.eu-west-2.amazonaws.com/assets/images/maps/guides/sicily-south@2x.png',
  5: 'https://villatravellers-prod.s3.eu-west-2.amazonaws.com/assets/images/maps/guides/puglia-north@2x.png',
  6: 'https://villatravellers-prod.s3.eu-west-2.amazonaws.com/assets/images/maps/guides/puglia-south@2x.png',
  7: 'https://villatravellers-prod.s3.eu-west-2.amazonaws.com/assets/images/maps/guides/puglia-central@2x.png',
};

export const GuideMapZone: React.FC<ISicilyMapZoneProps> = ({
  alt = '',
  region,
}) => {
  return (
    <div className="flex h-full aspect-square overflow-hidden relative scale-150">
      {
        <Image
          src={zoneImageUrl[region]}
          alt={alt}
          fill
          onError={(e) => e.currentTarget.classList.add('invisible')}
          className={
            'group-hover:-translate-x-1/2 z-10 scale-[2] translate-x-1/2 absolute opacity-90 duration-0 '
          }
          sizes="20vw"
          quality={100}
          style={{
            objectFit: 'contain',
          }}
        />
      }
    </div>
  );
};
